// src/utils/orgTheme.js
//
// Helpers for the org branding THEME (organizations/{id}.branding.theme).
//
//   'classic' (default) — coloured sidebar, gradient heroes. The original look.
//   'hub'               — the white-label look: light card sidebar, the client's
//                         own hub name with a "Powered by EAS" credit, flat brand
//                         heroes with an accent bar, a soft highlight surface.
//
// The theme is a property of the ORG, not of any one client: Hockey Alberta is
// the first to use 'hub', but nothing here names them. A bespoke look for a
// client is a branding configuration, never a component fork.

export const ORG_THEMES = [
    { id: 'classic', label: 'Classic — coloured sidebar' },
    { id: 'hub', label: 'Hub — white-label (light sidebar, hub name, accent bars)' }
];

export const isHubTheme = (orgData) =>
    !!(orgData?.branding?.enabled && orgData.branding.theme === 'hub');

// Hero / banner treatment. Classic keeps its gradient; Hub goes flat brand
// colour with a left accent bar, as in the mockups.
export const heroClass = (orgData, classicClass = 'bg-gradient-to-br from-brand-primary to-brand-dark') =>
    (isHubTheme(orgData) ? 'bg-brand-primary' : classicClass);

export const heroStyle = (orgData) =>
    (isHubTheme(orgData) ? { borderLeft: '6px solid var(--brand-accent)' } : undefined);

// Eyebrow text on a hero: accent-coloured in Hub, translucent white in classic.
export const heroEyebrowStyle = (orgData) =>
    (isHubTheme(orgData) ? { color: 'var(--brand-accent)' } : undefined);
